import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/research-bar')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/research-bar' || location.pathname === '/research-bar/') {
      throw redirect({ replace: true, to: '/recherche' })
    }
  },
  component: Outlet,
})
